import { render, staticRenderFns } from "./EnrollMain.vue?vue&type=template&id=12a61e55"
import script from "./EnrollMain.vue?vue&type=script&lang=js"
export * from "./EnrollMain.vue?vue&type=script&lang=js"
import style0 from "./EnrollMain.vue?vue&type=style&index=0&id=12a61e55&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports